export const SET_CUSTOMER_DATA = 'app/checkout/SET_CUSTOMER_DATA';
export const SET_CUSTOMER_SHIPPING_DATA = 'app/checkout/SET_CUSTOMER_SHIPPING_DATA';
